<template>
    <div class="card">
        <div class="card-header">Request Lifecycle History</div>
            <div class="card-body">

              <div class="card" v-for="phase in phases" :key="phase.id">
                <div class="card-header">{{phase.requestStatus}}</div>
                <div class="card-body">
                  <b-row>
                    <b-col cols="3"><strong>Date/Time Phase Entered</strong></b-col>
                    <b-col cols="8">{{phase.requestStatusInDatetime}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="3"><strong>Date/Time Phase Exited</strong></b-col>
                    <b-col cols="8">{{phase.requestStatusOutDatetime}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="3"><strong>Phase Duration (dd:hh:mm)</strong></b-col>
                    <b-col cols="8">{{phase.formattedDuration}}</b-col>
                  </b-row>
                  <b-row v-if="phase.contextAttribute1">
                    <b-col cols="3"><strong>{{phase.contextLabel1}}</strong></b-col>
                    <b-col cols="8">{{phase.contextAttribute1}}</b-col>
                  </b-row>
                  <b-row v-if="phase.contextAttribute2">
                    <b-col cols="3"><strong>{{phase.contextLabel2}}</strong></b-col>
                    <b-col cols="8">{{phase.contextAttribute2}}</b-col>
                  </b-row>
                  <b-row v-if="phase.contextAttribute3">
                    <b-col cols="3"><strong>{{phase.contextLabel3}}</strong></b-col>
                    <b-col cols="8">{{phase.contextAttribute3}}</b-col>
                  </b-row>
                  <b-row v-if="phase.contextAttribute4">
                    <b-col cols="3"><strong>{{phase.contextLabel4}}</strong></b-col>
                    <b-col cols="8">{{phase.contextAttribute4}}</b-col>
                  </b-row>
                  <b-row v-if="phase.contextAttribute5">
                    <b-col cols="3"><strong>{{phase.contextLabel5}}</strong></b-col>
                    <b-col cols="8">{{phase.contextAttribute5}}</b-col>
                  </b-row>
                  <b-row v-if="phase.comments">
                    <b-col cols="3"><strong>Comments</strong></b-col>
                    <b-col cols="8">{{phase.comments}}</b-col>
                  </b-row>
                </div>
              </div>

            </div>
    </div>
</template>

<script>
    import axios from "axios"

  export default {
    props: {
        requestId: [Number],
    },
    data() {
      return {
        phases: [],
      }
    },
    created() {
      this.fetchLifecycles();
    },
    methods: {
      fetchLifecycles() {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/lifecycle/${this.requestId}`)
            .then(response => {
              this.phases = response.data
          })
      }
    },
  }
</script>